import react,{Component} from 'react';
import { DKLabel, DKButton,showToast,TOAST_TYPE, DKSpinner,DKCalendar,DKIcon,DKIcons,DKLine,DKInput,INPUT_VIEW_DIRECTION,Toggle, showLoader, removeLoader } from "deskera-ui-library";
import RouteManager from '../../../../managers/RouteManager';
import date_range from "../../../../assets/icons/white/date_range.svg";
import moment from 'moment';
import { COUNTRY_CODE, DATE_FORMAT, INPUT_TYPE } from '../../../../constants/Constant';
import PayrollService from '../../../../services/PayrollService';
import ReportService from '../../../../services/ReportService';
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from '../../../../managers/TenantManagerService';
export default class PayrollSummaryReport extends Component{
    selectedUser = [];
    constructor(props){
        super(props)
        this.state = {
            timePeriod: {
                toggle: false,
                startDate: moment().startOf('month'),
                endDate: moment().endOf("month"),
                defaultDate: false,
                hasError: false,
                loadingEmployee : false
            },
            exportAll:true,
            users:[]
        }
        this.getUsers();
    }
    componentDidMount() {
        RouteManager.setPresenter(this);
    }
    async getUsers(){

        const response = await PayrollService.getUsersList();
        if(response['status'] == 'OK') {

            this.setState({users:response['users']})
        }
        removeLoader()
    }
    getTimePeriod () {
        const dateFormat = TenantService.get(TENANT.DATE_FORMAT);
        const timePeriod = this.state.timePeriod
        return timePeriod.startDate && timePeriod.endDate ? `${moment(timePeriod.startDate).format(dateFormat)} - ${moment(timePeriod.endDate).format(dateFormat)}` : '';
    }
    onExportToggle(){
        if(!this.state.users || this.state.users.length === 0) {
            this.setState({loadingEmployee:true})
        }

        if(!this.state.exportAll) {
            this.selectedUser = []
        }

        this.setState({
            exportAll: !this.state.exportAll
        })
    }
    export(){
        this.setState({...this.state})
        if(!this.state.exportAll && this.selectedUser.length == 0) {
            return
        }
        if(this.state.timePeriod.hasError) {
            return
        }
        let users = []
        this.selectedUser.forEach(ind=>{
            users.push(this.state.users[ind].userId)
        })
        ReportService.apiConfig = {
            format: 'XLSX',
            fromDate: moment(this.state.timePeriod.startDate).format('YYYY-MM-DD'),
            toDate: moment(this.state.timePeriod.endDate).format('YYYY-MM-DD'),
            exportAll: this.state.exportAll,
            selectedEmployee: users.join()
        }
        ReportService.exportPayrollSummaryReport().then(
            (response) => {

                saveAs(response, `Payroll_Summary_Report_${this.getTimePeriod()}.xlsx`);
                showToast("Download completed", TOAST_TYPE.SUCCESS);
            }, (error) => {
                showToast("Selected employees for duration there no Payroll Summary Report available", TOAST_TYPE.FAILURE);
            }
        )
    }
    render(){
        return(
            <div className="parent-width">
                <DKLabel text="Payroll Summary Report" className="fw-m fs-l" />
                <div className="bg-white pb-l card-shadow mt-l">
                    <DKLabel text="Generate Payroll Summary Report" className="fw-m fs-l p-l" />
                    <DKLine  className="bg-gray3  "/>
                    <div className="d-flex mt-s row row-responsive">
                        <div className="p-h-l web-width-30" >
                            <div className="web-width-70">
                                <div className="row">
                                    <DKInput
                                        title={"Time Period"}
                                        type={INPUT_TYPE.TEXT}
                                        value={this.getTimePeriod()}
                                        required={true}
                                        readOnly={true}
                                        canValidate={true}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    />
                                    <DKIcon
                                        className={`mr-s cursor-hand z-index-1 mt-xl pt-xs`}
                                        style={{
                                            marginLeft: "-30px",
                                            filter: "contrast(0.5)"

                                        }}
                                        src={date_range}
                                        onClick={() => {
                                            this.setState({
                                                timePeriod: {
                                                    toggle: true,
                                                    startDate: this.state.timePeriod.startDate,
                                                    endDate: this.state.timePeriod.endDate,
                                                    defaultDate: true,
                                                    hasError: false
                                                }
                                            })
                                        }}
                                    />
                                    {this.state.timePeriod.toggle && <DKCalendar
                                        className="position-absolute border-m shadow-m bg-white z-index-1 mt-s"
                                        style={{ top: 90, width: 65, "z-index": "1" }}
                                        isDateRange={true}
                                        startDate={this.state.timePeriod.startDate ? new Date(this.state.timePeriod.startDate) : new Date()}
                                        endDate={this.state.timePeriod.endDate ? new Date(this.state.timePeriod.endDate) : new Date()}
                                        onClose={()=>{
                                            if(moment(this.state.timePeriod.startDate).diff(this.state.timePeriod.endDate) <= 0 || this.state.timePeriod.endDate == null) {
                                                this.setState({
                                                    timePeriod:{
                                                        toggle: false,
                                                        startDate: this.state.timePeriod.startDate,
                                                        endDate: this.state.timePeriod.endDate,
                                                        defaultDate: false,
                                                        hasError: false
                                                    }
                                                });
                                            } else {
                                                this.setState({
                                                    timePeriod: {
                                                        toggle: false,
                                                        startDate: this.state.timePeriod.startDate,
                                                        endDate: this.state.timePeriod.endDate,
                                                        defaultDate: false,
                                                        hasError: true,
                                                        errorMsg: "End date should not be less than Start date"
                                                    }
                                                });
                                            }
                                        }}
                                        onSelectDate={(start, end) => {
                                            if(start && end) {
                                                let startDate = start //timePeriod.defaultDate ? start : timePeriod.startDate;
                                                let endDate = end//timePeriod.defaultDate ? timePeriod.endDate : end;
                                                if(moment(startDate).diff(endDate) <= 0 || endDate == null) {
                                                    this.setState({
                                                        timePeriod:{
                                                            toggle: false,
                                                            startDate: startDate,
                                                            endDate: endDate,
                                                            defaultDate: false,
                                                            hasError: false
                                                        }
                                                    });
                                                } else {
                                                    this.setState({
                                                        timePeriod: {
                                                            toggle: false,
                                                            startDate: startDate,
                                                            endDate: endDate,
                                                            defaultDate: false,
                                                            hasError: true,
                                                            errorMsg: "End date should not be less than Start date"
                                                        }
                                                    })
                                                }
                                            }
                                        }}
                                    />}
                                </div>
                                {this.state.timePeriod.hasError && <DKLabel
                                    className="mt-xs text-red"

                                    text={this.state.timePeriod.errorMsg}
                                />}
                            </div>
                        </div>
                        <div className="d-flex web-width-30 justify-content-center " style={{marginTop: '30px'}}>
                            <DKLabel
                                className="text-align-left ml-s mr-l"
                                text={"All Employees"}
                            />
                            <Toggle
                                className="border-n"
                                isOn={!this.state.exportAll}
                                onChange={() => this.onExportToggle()}
                            />
                            <DKLabel
                                className="text-align-left ml-l mr-l fw-m"
                                text={"Specific Employees"}
                            />
                        </div>
                        <div className="web-width-30 mobile-horizontal-width padding-top-mobile">
                            {(!this.state.exportAll && this.state.users.length === 0) && <div style={{marginLeft : "-242px", marginBottom : "-22px"}}><DKSpinner className="" /></div>}
                            <DKInput
                            title="Employee"
                            value={this.selectedUser}
                            type={INPUT_TYPE.MULTI_SELECT}
                            required={!this.state.exportAll}
                            canValidate={!this.state.exportAll}
                            readOnly={this.state.exportAll}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            options={this.state.users.map(res=>`${res.firstName} ${res.lastName}`)}
                            errorMessage="Please select employee"
                            onChange={(value)=>{
                                this.selectedUser = value
                            }}
                            />
                        </div>
                        <div className="mb-xs ml-l" style={{marginTop: '30px'}}>
                            <DKButton
                            title="Export"
                            icon={DKIcons.white.ic_export}
                            className="bg-app text-white"
                            onClick={()=>{
                                this.export();
                            }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
